import {useState, useCallback} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useDisclosure} from "../../../hooks/useDisclosure";
import {deleteAlertData, toggleAlertState} from "../../../redux/Actions/alerts.actions";
import {filterScopeBySitesAndLocations} from "../../../utils/filterScope";
import {useFetchAlerts} from "./useAlertTableData";

export const useAlertTableActions = (fetchAfterDelete = () => {}) => {
  const {
    isOpen: isDeleteModalOpen,
    onClose: closeDeleteModal,
    onOpen: openDeleteModal,
  } = useDisclosure();
  const {
    isOpen: isEditModalOpen,
    onClose: closeEditModal,
    onOpen: openEditModal,
  } = useDisclosure();
  const {
    isOpen: isHandoffModalOpen,
    onClose: closeHandoffModal,
    onOpen: openHandoffModal,
  } = useDisclosure();
  const dispatch = useDispatch();
  const {refetch} = useFetchAlerts();
  const navigate = useNavigate();
  const [metricType, setMetricType] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const clearSelectedData = () => {
    setMetricType(null);
    setSelectedRow(null);
  };

  const handleActionSelection = useCallback(
    (action, data) => {
      setMetricType(data.type === "Metric" ? "metric" : "downtime");
      setSelectedRow({
        ...data,
        scope: filterScopeBySitesAndLocations(data.scope, data.sites, data.locations),
      });
      switch (action) {
        case "Edit":
          openEditModal();
          break;
        case "History":
          navigate(`/app/system-alert-history/${data.id}`);
          break;
        case "Handoff":
          openHandoffModal();
          break;
        case "Delete":
          openDeleteModal();
          break;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleDelete = () => {
    const callback = () => {
      closeDeleteModal();
      clearSelectedData();
      fetchAfterDelete();
    };
    dispatch(deleteAlertData(selectedRow.id, callback));
  };

  const handleDeleteModalClose = () => {
    closeDeleteModal();
    clearSelectedData();
  };

  const handleEditModalClose = () => {
    closeEditModal();
    clearSelectedData();
  };

  const handleHandoffModalClose = () => {
    closeHandoffModal();
    clearSelectedData();
  };

  const handleToggle = (data) => {
    dispatch(
      toggleAlertState(
        {
          id: data.id,
          requestData: {enabled: !data.enabled},
        },
        refetch
      )
    );
  };

  return {
    closeDeleteModal: handleDeleteModalClose,
    closeEditModal: handleEditModalClose,
    closeHandoffModal: handleHandoffModalClose,
    handleActionSelection,
    handleDelete,
    handleToggle,
    isDeleteModalOpen,
    isEditModalOpen,
    isHandoffModalOpen,
    metricType,
    selectedRow,
  };
};
